import callApiAxiosClient from '../../axios/axios_client';
import { technicalIncidentStatusList } from '../../models';

async function getTechnicalIncidentStatuses(): Promise<technicalIncidentStatusList> {
  const token = JSON.parse(localStorage.getItem('user')!);
  const authorization = 'Bearer ' + token.token;

  return callApiAxiosClient<technicalIncidentStatusList>({
    method: 'get',
    url: 'technicalincidents/statuses',
    headers: {
      'Content-Type': 'Application/json',
      Authorization: authorization,
    },
  });
}

export default getTechnicalIncidentStatuses;
